module.exports = __webpack_public_path__ + "9df2e1a34c2a12902afc40949b9365de.png";